import {makeBFFApiUrl} from 'main/factories/http';
import {makeAuthorizeHttpClientDecorator} from 'main/factories/decorators';
import {BookingFlowEndPoints} from 'main/factories/usecases/endpoints';
import {GetHealthDistricts} from 'domain/usecases/private/booking-flow/health/get-health-districts';
import {RemoteGetHealthDistricts} from 'data/usecases/private/booking-flow/health/remote-get-health-districts';

export const makeGetHealthDistricts = (): GetHealthDistricts =>
	new RemoteGetHealthDistricts(
		makeBFFApiUrl(BookingFlowEndPoints.healthDistricts),
		makeAuthorizeHttpClientDecorator(),
	);
